import React, { useEffect, useState } from 'react';
import './ExecutiveManagement.scss';

const ExecutiveManagement = () => {
    const [executives, setExecutives] = useState([]);
    const [openIndex, setOpenIndex] = useState(0);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const shouldClearCache = params.get('clear') === 'yes-please';
        const apiUrl = shouldClearCache ? 'https://www.marketaxess.com/json/leadership?clearCache=Y' : 'https://www.marketaxess.com/json/leadership';

        fetch(apiUrl)
            .then(res => res.json())
            .then(data => {
                if (data && data.GetPeopleListResult) {
                    const sorted = data.GetPeopleListResult.sort((a, b) => a.Rank - b.Rank) || [];
                    setExecutives(sorted);
                }
            })
            .catch(err => console.error('Failed to fetch executive data:', err));
    }, []);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="executive-management">
            {executives.map((exec, index) => {
                const name = `${exec.FirstName.trim()} ${exec.LastName.trim()}`;
                const title = exec.Title || '';
                const photo = exec.HighResolutionPhotoPath || exec.PhotoPath || '';
                const bio = exec.Description || '';

                return (
                    <div key={exec.PersonId} className="executive">
                        <button className="executive__header" onClick={() => toggleAccordion(index)}>
                            <div className="singleAccordionItem__title">
                                <h3>{name}
                                <span className="executive__title">{title}</span>
                                </h3>

                            </div>
                        </button>
                        {openIndex === index && (
                            <div className="executive__details">
                                <div className="executive__image">
                                    {photo && <img src={photo} alt={name} />}
                                </div>
                                <div
                                    className="executive__bio"
                                    dangerouslySetInnerHTML={{ __html: bio }}
                                />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ExecutiveManagement;



// WEBPACK FOOTER //
// ./frontend/components/Shortcodes/ExecutiveManagement.jsx